import commonService from "./common-service";

class ScreenService {
  async getScreens(month, year) {
    try {
      const response = await commonService.getFromServer(
        "EOM/Screens/" + year + "/" + month,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error getting data");
      }
    } catch (e) {
      throw new Error("Error getting data");
    }
  }

  async updateScreen(id, obj) {
    try {
      const response = await commonService.updateToServer(
        "EOM/Screens/" + id,
        obj
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error updating status");
      }
    } catch (e) {
      throw new Error("Error updating status");
    }
  }
  async createIndigentCheck(obj) {
    try {
      const response = await commonService.postToServer(
        "EOM/IndigentCheck",
        obj
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error updating status");
      }
    } catch (e) {
      throw new Error("Error updating status");
    }
  }
  async createSHP(obj) {
    try {
      const response = await commonService.postToServer(
        "EOM/SHPTop10?year=" +
          obj?.year +
          "&month=" +
          obj?.month +
          "&amt_due=" +
          obj?.amt_due,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error updating status");
      }
    } catch (e) {
      throw new Error("Error updating status");
    }
  }
  async clearScreen(id) {
    try {
      const response = await commonService.postToServer(
        "EOM/Screens/Clear/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error updating status");
      }
    } catch (e) {
      throw new Error("Error updating status");
    }
  }
  async importData(payload) {
    try {
      const response = await commonService.postToServer(
        "EOM/Import?year=" + payload.year + "&month=" + payload.month,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error getting data");
      }
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async getMasterErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/FacilityMaster/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async downloadMasterData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/FacilityMaster/Errors?year=" + year + "&month=" + month,
        { fileName: "AllFacilities.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async downloadDSData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/DiseaseStates/Errors?year=" + year + "&month=" + month,
        { fileName: "AllDiseaseStates.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async downloadUCData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/UnitCost/Errors?year=" + year + "&month=" + month,
        { fileName: "UnitCost.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async downloadAZData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/AnyZeros/Errors?year=" + year + "&month=" + month,
        { fileName: "AnyZeros.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async getDSErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/DiseaseStates/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getAZErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/AnyZeros/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getPCErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/PriceCodes/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async downloadPCData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/PriceCodes/Errors?year=" + year + "&month=" + month,
        { fileName: "PriceCodes.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async getCensusErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/Census/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getCFErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/CoreCivicFormulary/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getUnitCostErrors(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/UnitCost/Errors?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async downloadCFData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/CoreCivicFormulary/Errors?year=" + year + "&month=" + month,
        { fileName: "Corecivic formula.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }

  async downloadCensusData(year, month) {
    try {
      await commonService.downloadFromServer(
        "EOM/Census/Errors?year=" + year + "&month=" + month,
        { fileName: "Census.xlsx" }
      );
    } catch (e) {
      throw new Error("Error getting data");
    }
  }

  async downloadData(year, month) {
    try {
      const resp = await commonService.getFromServer(
        "EOM/Download?year=" + year + "&month=" + month,
        {}
      );
      return resp;
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async postDownloadData(params) {
    try {
      const resp = await commonService.postToServer("EOM/Download", params);
      return resp;
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async deleteDownloadData(id) {
    try {
      const resp = await commonService.deleteToServer("EOM/Download/" + id);
      return resp;
    } catch (e) {
      throw new Error("Error getting data");
    }
  }
  async downloadEOMFile(id) {
    try {
      await commonService.downloadFromServer(
        "EOM/Download/" + id + "/File",
        { }
      );
    } catch (e) {
      throw new Error("Error downloading file");
    }
  }
  async executeStepOne(year, month) {
    try {
      const response = await commonService.postToServer(
        "EOM/ExecuteStep1?year=" + year + "&month=" + month
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new ScreenService();
